export default "__VITE_ASSET__28289e97__"